// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LocaleConstants$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/constants/LocaleConstants.mjs";
import * as FareEstimateStore$PorterinFeature from "../../../core/constants/FareEstimateStore.mjs";
import * as FareEstimateStoreV1$PorterinFeature from "../../../../containers/fare-estimate-v1/domain/store/FareEstimateStoreV1.mjs";

var error_something_wrong = {
  text: FareEstimateStoreV1$PorterinFeature.error_something_wrong_text,
  sub_text: FareEstimateStoreV1$PorterinFeature.error_something_wrong_sub_text
};

function getErrorUnserviceablePickup(locale) {
  return {
          text: locale === LocaleConstants$PorterinUtils.bn_BD ? FareEstimateStore$PorterinFeature.error_unserviceable_text_bn : FareEstimateStore$PorterinFeature.error_unserviceable_text,
          sub_text: locale === LocaleConstants$PorterinUtils.bn_BD ? FareEstimateStore$PorterinFeature.error_unserviceable_sub_text_pickup_bn : FareEstimateStore$PorterinFeature.error_unserviceable_sub_text_pickup
        };
}

function getErrorUnserviceableDropoff(locale) {
  return {
          text: locale === LocaleConstants$PorterinUtils.bn_BD ? FareEstimateStore$PorterinFeature.error_unserviceable_text_bn : FareEstimateStore$PorterinFeature.error_unserviceable_text,
          sub_text: locale === LocaleConstants$PorterinUtils.bn_BD ? FareEstimateStore$PorterinFeature.error_unserviceable_sub_text_dropoff_bn : FareEstimateStore$PorterinFeature.error_unserviceable_sub_text_dropoff
        };
}

function getPickupButtonLabel(locale) {
  if (locale === LocaleConstants$PorterinUtils.bn_BD) {
    return FareEstimateStore$PorterinFeature.error_unserviceable_button_pickup_bn;
  } else {
    return FareEstimateStore$PorterinFeature.error_unserviceable_button_pickup;
  }
}

function getDropOffButtonLabel(locale) {
  if (locale === LocaleConstants$PorterinUtils.bn_BD) {
    return FareEstimateStore$PorterinFeature.error_unserviceable_button_dropoff_bn;
  } else {
    return FareEstimateStore$PorterinFeature.error_unserviceable_button_dropoff;
  }
}

var commonAssetPath = "/assets/booking-flow/";

var error_invalid_location = {
  src: "https://nest-platform-assets.porter.in/unserviceable_61cacbbd74/unserviceable_61cacbbd74.svg",
  width: 158.0,
  height: 158.0,
  alt: "Map Pin"
};

var error_something_went_wrong = {
  src: "https://nest-platform-assets.porter.in/error_ef88199d3d/error_ef88199d3d.svg",
  width: 150.0,
  height: 150.0,
  alt: "Map Pin"
};

export {
  commonAssetPath ,
  error_invalid_location ,
  error_something_went_wrong ,
  error_something_wrong ,
  getErrorUnserviceablePickup ,
  getErrorUnserviceableDropoff ,
  getPickupButtonLabel ,
  getDropOffButtonLabel ,
}
/* FareEstimateStore-PorterinFeature Not a pure module */
